var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcPlayerFullscreenClose = function SvgIcPlayerFullscreenClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_player_fullscreen copy")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_player_fullscreen-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_player_minimalize",
    stroke: "#FFFFFF",
    strokeWidth: 2.75
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    transform: "translate(5.376091, 5.374329) scale(-1, -1) translate(-5.376091, -5.374329) ",
    points: "1.37609132 9.37432861 1.37609132 1.37432861 9.37609132 1.37432861"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4-Copy",
    transform: "translate(19.621810, 5.374329) scale(1, -1) translate(-19.621810, -5.374329) ",
    points: "15.6218102 9.37432861 15.6218102 1.37432861 23.6218102 1.37432861"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4-Copy-2",
    points: "15.6218102 23.62 15.6218102 15.62 23.6218102 15.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4-Copy-3",
    transform: "translate(5.348328, 19.624588) scale(-1, 1) translate(-5.348328, -19.624588) ",
    points: "1.34832764 23.624588 1.34832764 15.624588 9.34832764 15.624588"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPlayerFullscreenClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_player_fullscreen_close.84cb8231.svg";
export { ForwardRef as ReactComponent };